import React from 'react'

export default function Button ({onClick, enabled=true, className, children}) {
  const css = `button ${className || ''} ${enabled ? '' : 'disabled'}`
  return <a className={css} onClick={onClick}>{children}</a>
}
